import React, { useState } from "react";
import "./Msign.css";
import usergif from "../assests/back8.png";
import usergifs from "../assests/back1.png";
import van from "../assests/trolley.png";
import vans from "../assests/trolley2.png";
import bgu from "../assests/bgu.png";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Usersign() {
  const [isSignIn, setIsSignIn] = useState(true);
  const [usignup, setUsignup] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    confirmpassword: "",
  });

  const [usignin, setUsignin] = useState({
    name: "",
    password: "",
  });

  const navigate = useNavigate(); 

  const handlesingup = async () => {
    const { name, phone, email, password, confirmpassword } = usignup;

    if (!name || !phone || !email || !password || !confirmpassword) {
      toast.error("Please fill in all the fields");
      return;
    }

    if (password !== confirmpassword) {
      toast.error("Passwords do not match");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/signup.php`;
    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone_no", phone);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("type", "form");
    formData.append("format", "customer");

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "User created successfully") {
        setUsignup({
          name: "",
          phone: "",
          email: "",
          password: "",
          confirmpassword: "",
        });
        toast.success("User created successfully");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handlesingin = async () => {
    const { name, password } = usignin;

    if (!name || !password) {
      toast.error("Please enter both username and password");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/signin.php`;
    const formData = new FormData();
    formData.append("name", name);
    formData.append("password", password);
    formData.append("format", "customer");

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Login successful") {
        localStorage.setItem(
          "userData",
          JSON.stringify({
            id: data.id,
            username: data.username,
            name: data.name,
          })
        );
        navigate("/"); 
        setUsignin({ name: "", password: "" });
        toast.success("Logged in successfully");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <div className={`auth-screen ${isSignIn ? "" : "right-panel-active"}`}>
      <img src={bgu} alt="bgm" className="signidn-bg" />
      <div className="form-container sign-up-container">
        <div className="div">
          <h1 className="heading">Create Account</h1>
          <input
            type="text"
            placeholder="Name"
            required
            value={usignup?.name}
            onChange={(e) =>
              setUsignup((pv) => ({ ...pv, name: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="Phone Number"
            required
            value={usignup?.phone}
            onChange={(e) =>
              setUsignup((pv) => ({ ...pv, phone: e.target.value }))
            }
          />
          <input
            type="email"
            placeholder="Email"
            required
            value={usignup?.email}
            onChange={(e) =>
              setUsignup((pv) => ({ ...pv, email: e.target.value }))
            }
          />
          <input
            type="password"
            placeholder="Password"
            required
            value={usignup?.password}
            onChange={(e) =>
              setUsignup((pv) => ({ ...pv, password: e.target.value }))
            }
          />
          <input
            type="password"
            placeholder="Confirm Password"
            required
            value={usignup?.confirmpassword}
            onChange={(e) =>
              setUsignup((pv) => ({ ...pv, confirmpassword: e.target.value }))
            }
          />
          <button className="mbutton" onClick={handlesingup}>Sign Up</button>
        </div>
      </div>

      <div className="form-container sign-in-container">
        <div className="div">
          <h1 className="heading">Sign in</h1>
          <input
            type="text"
            placeholder="Email, Username or Phone Number"
            required
            value={usignin?.name}
            onChange={(e) =>
              setUsignin((pv) => ({ ...pv, name: e.target.value }))
            }
          />
          <input
            type="password"
            placeholder="Password"
            required
            value={usignin?.password}
            onChange={(e) =>
              setUsignin((pv) => ({ ...pv, password: e.target.value }))
            }
          />
          <button className="mbutton" onClick={handlesingin}>Sign In</button>
        </div>
      </div>

      <div className={`van-wrapper ${isSignIn ? "" : "slide-right"}`}>
        <img src={vans} alt="Delivery Van" className="van-img" />
      </div>

      <div className={`van-wrappers ${isSignIn ? "" : "slide-left"}`}>
        <img src={van} alt="Delivery Van 2" className="van-img" />
      </div>

      <div className="overlay-container">
        <div className="overlay">
          <img src={usergif} alt="Vendorsignin" className="vendorsignin" />
          <div className="overlay-panel overlay-left">
            <h1>Welcome Back!</h1>
            <p>To keep connected with us, please login with your info</p>
            <button className="mbutton ghost" onClick={() => setIsSignIn(true)}>
              Sign In
            </button>
          </div>
          <img src={usergifs} alt="Vendorsignin" className="vendorsignup" />
          <div className="overlay-panel overlay-right">
            <h1>Hello, Friend!</h1>
            <p>Enter your details and start your journey with us</p>

            <button className="mbutton ghost" onClick={() => setIsSignIn(false)}>
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Usersign;